import { useState } from "react";
import { api, formatApiError, CATEGORIES } from "@/lib/pfc";
import { toast } from "sonner";

export default function Submit() {
  const [form, setForm] = useState({
    full_name: "", email: "", category: "music", headline: "", story: "", social_link: "", image_url: "",
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/submissions", form);
      toast.success("Your story has been submitted. PFC editors will be in touch.");
      setForm({ full_name: "", email: "", category: "music", headline: "", story: "", social_link: "", image_url: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const inp = "w-full bg-ink-700 border border-white/10 text-white px-4 py-3 font-body focus:border-pfc-gold focus:outline-none focus:ring-1 focus:ring-pfc-gold";

  return (
    <div className="max-w-[900px] mx-auto px-5 lg:px-10 py-14" data-testid="submit-page">
      <div className="mb-10">
        <div className="label text-pfc-gold mb-3">Submit Your Story</div>
        <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl text-white uppercase leading-[0.9]">
          Tell <span className="gold-text">Us</span> What<br /> The World Should <span className="silver-text">Know.</span>
        </h1>
        <p className="text-white/60 mt-4 font-body max-w-2xl">
          Apply to be featured on Public Figures Campaign. Our editors review every submission and reach out within 5 business days.
        </p>
      </div>

      <form onSubmit={submit} className="space-y-5" data-testid="submit-form">
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <label className="label text-white/70 mb-2 block">Full Name</label>
            <input required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} className={inp} data-testid="submit-name" />
          </div>
          <div>
            <label className="label text-white/70 mb-2 block">Email</label>
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inp} data-testid="submit-email" />
          </div>
        </div>
        <div>
          <label className="label text-white/70 mb-2 block">Category</label>
          <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className={inp} data-testid="submit-category">
            {CATEGORIES.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
          </select>
        </div>
        <div>
          <label className="label text-white/70 mb-2 block">Headline</label>
          <input required value={form.headline} onChange={(e) => setForm({ ...form, headline: e.target.value })} placeholder="One line that captures who you are…" className={inp} data-testid="submit-headline" />
        </div>
        <div>
          <label className="label text-white/70 mb-2 block">Your Story</label>
          <textarea required rows={8} value={form.story} onChange={(e) => setForm({ ...form, story: e.target.value })} className={inp} data-testid="submit-story" />
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <label className="label text-white/70 mb-2 block">Social Link (optional)</label>
            <input value={form.social_link} onChange={(e) => setForm({ ...form, social_link: e.target.value })} placeholder="https://instagram.com/…" className={inp} data-testid="submit-social" />
          </div>
          <div>
            <label className="label text-white/70 mb-2 block">Cover Image URL (optional)</label>
            <input value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} placeholder="https://…" className={inp} data-testid="submit-image" />
          </div>
        </div>
        <button type="submit" disabled={loading} className="font-sub uppercase tracking-[0.25em] text-sm px-10 py-4 bg-pfc-gold text-ink-900 hover:bg-pfc-gold-bright transition disabled:opacity-50" data-testid="submit-btn">
          {loading ? "Sending…" : "Submit My Story"}
        </button>
      </form>
    </div>
  );
}
